import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import React, { Fragment } from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { Icon } from '../../../Icon';
import { Tooltip } from '../../../Tooltip';
import { Organization } from '../../../Organization';
import { getProductTransactionableOrganizations } from '../../utils';
import { Inner } from './partials';
export var ProductOrganizations = function ProductOrganizations(_ref) {
  var product = _ref.product,
    title = _ref.title,
    _ref$whiteList = _ref.whiteList,
    whiteList = _ref$whiteList === void 0 ? [] : _ref$whiteList;
  var organizations = getProductTransactionableOrganizations(product.entity);
  var displayOrganizations = organizations.filter(function (item) {
    return !whiteList.length || whiteList.includes(item.id);
  });
  if (!displayOrganizations.length) {
    return null;
  }
  var realTitle = whiteList.length ? 'Distribuidor patrocinado:' : title;
  return React.createElement(Inner, null, realTitle ? React.createElement("span", null, realTitle) : null, displayOrganizations.length === 1 ? React.createElement(React.Fragment, null, displayOrganizations.map(function (organization, index) {
    return React.createElement(Organization, {
      key: index,
      entity: organization,
      variant: "badge",
      withLink: false,
      size: 0
    });
  })) : React.createElement(Flex, null, displayOrganizations.map(function (organization, index) {
    return React.createElement(Tooltip, {
      key: index,
      tip: organization.displayName,
      from: "left"
    }, React.createElement(Icon, {
      image: "/image/".concat(organization.icon),
      type: "company",
      size: 0,
      alt: organization.displayName
    }));
  })));
};